module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#32508c\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M12,2c5.5,0,10,4.5,10,10s-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2z M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12\nS18.6,0,12,0z M18,16.5L13.4,12L18,7.4L16.5,6L12,10.6L7.4,6L6,7.5l4.6,4.6L6,16.6L7.5,18l4.6-4.6l4.6,4.6C16.6,18,18,16.5,18,16.5z\n\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/close.svg
// module id = 786
// module chunks = 1